// Service for employee contract delete operations
// DELETE /v{version}/employees/{employeeId}/contracts/{employeeContractId}
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_DeleteEmployeeContractOut,
  DeleteEmployeeContractRequest,
  DeleteEmployeeContractResponse,
} from '../types/employeeContractDelete.types';
import { mapDeleteRequestToTransport, mapDeleteTransportToResponse } from '../mappers/employeeContractDelete.mapper';


/**
 * Service for employee contract delete operations
 */
export class EmployeeContractDeleteService {
  /**
   * DELETE employee contract
   * Endpoint: DELETE /v{version}/employees/{employeeId}/contracts/{employeeContractId}
   * 
   * @param request - Request with employeeId, contractId, contractNumberREX
   * @returns ApiResponse with delete result
   */
  async delete(
    request: DeleteEmployeeContractRequest,
  ): Promise<ApiResponse<DeleteEmployeeContractResponse>> {
    // employeeId and contractId go in the path
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_CONTRACT.DELETE(
      request.employeeId,
      request.contractId,
    );
    
    // Map to transport DTO (contractNumberREX in body)
    const transportDto = mapDeleteRequestToTransport(request);
    
    // Execute DELETE request
    const response = await apiClient.delete<LC_DeleteEmployeeContractOut>(endpoint, transportDto);
    
    // Map response if successful
    if (response.success && response.data) {
      return {
        ...response,
        data: mapDeleteTransportToResponse(response.data),
      };
    }
    
    // If no data, return error response properly typed
    return {
      ...response,
      data: null,
    } as ApiResponse<DeleteEmployeeContractResponse>;
  }
}

export const employeeContractDeleteService = new EmployeeContractDeleteService();
